// extracted by mini-css-extract-plugin
module.exports = {"marketing__divider":"divider_marketing__divider__6Oszq","marketing__divider_icon":"divider_marketing__divider_icon__yCNU4"};